import { submitSeedingContent } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type { SubmitSeedingContentServiceRequest } from './submit-seeding-content.dto';
import {
  SubmitSeedingContentServiceRequestSchema,
  SubmitSeedingContentServiceResponseSchema,
} from './submit-seeding-content.dto';

export const submitSeedingContentService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(SubmitSeedingContentServiceRequestSchema),
    // NOTE: 204 No Content — 응답 본문 없이 await 만.
    async (request: SubmitSeedingContentServiceRequest): Promise<void> => {
      await submitSeedingContent(request);
    },
    validateServiceResponse(SubmitSeedingContentServiceResponseSchema),
  ),
);
